import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import {
  HOURS_ID,
  MINUTES_ID,
  TIME_PERIOD_ID,
  TIME_DROPDOWN_ID,
} from '../consts';

const useInputNavigation = () => {
  const hoursRef = useRef<HTMLInputElement | null>(null);
  const minutesRef = useRef<HTMLInputElement | null>(null);
  const timePeriodRef = useRef<HTMLInputElement | null>(null);

  const [focusedId, setFocusedId] = useState<string>();

  useEffect(() => {
    switch (focusedId) {
      case HOURS_ID:
        hoursRef.current?.focus();
        break;
      case MINUTES_ID:
        minutesRef.current?.focus();
        break;
      case TIME_PERIOD_ID:
        timePeriodRef.current?.focus();
        break;
      default:
        break;
    }
  }, [focusedId, hoursRef, minutesRef, timePeriodRef]);

  const focusHourInput = useCallback(() => setFocusedId(HOURS_ID), []);
  const focusMinuteInput = useCallback(() => setFocusedId(MINUTES_ID), []);
  const focusTimePeriodInput = useCallback(
    () => setFocusedId(TIME_PERIOD_ID),
    [],
  );
  const focusToggleButton = useCallback(() => {
    const dropdown = document.getElementById(TIME_DROPDOWN_ID);
    const toggleButton = dropdown?.querySelector('button');

    toggleButton?.focus();
  }, []);

  const hourInputProps = useMemo(
    () => ({
      ref: hoursRef,
      onArrowRight: focusMinuteInput,
      onArrowLeft: focusToggleButton,
    }),
    [focusMinuteInput, focusToggleButton],
  );

  const minuteInputProps = useMemo(
    () => ({
      ref: minutesRef,
      onArrowRight: focusTimePeriodInput,
      onArrowLeft: focusHourInput,
    }),
    [focusHourInput, focusTimePeriodInput],
  );

  const timePeriodInputProps = useMemo(
    () => ({
      ref: timePeriodRef,
      onArrowRight: focusToggleButton,
      onArrowLeft: focusMinuteInput,
    }),
    [focusMinuteInput, focusToggleButton],
  );

  return {
    hourInputProps,
    minuteInputProps,
    timePeriodInputProps,
    focusedId,
    setFocused: setFocusedId,
  };
};

export default useInputNavigation;
